export const brand = {
  name: "DemandRelay",
  eyebrow: "Your AI distribution agency",
  headline: "Turn market signal into compounding demand.",
  subhead:
    "DemandRelay researches your market, sharpens your ICP, creates conversion-ready pages, finds qualified accounts, and turns buyer feedback into better positioning and product decisions.",
  promise: "One shared context for research, positioning, pages, outreach, calls and market learning.",
  founderQuote:
    "Built for founders making something remarkable — and tired of distribution being the thing that holds it back.",
  launchWindow: "Private beta · 2026",
  contactLabel: "Contact the founders",
} as const;

export type Brand = typeof brand;
